export default __webpack_public_path__ + "static/media/wateringcan.70a2f901.png";